
import React, {useState} from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useDispatch, useSelector} from 'react-redux'
import axios from 'src/common/razzle-platform-components/axios'
import {handleErrors, isClient} from 'src/common/razzle-platform-components/utils'
import {useAlert} from 'src/common/razzle-platform-components/alert'
import {useAuth} from 'src/common/razzle-platform-user/Authentication'
import { useIntl } from 'src/common/razzle-platform-translate'
import DefaultBookmarkButton from 'src/common/razzle-platform-bookmarkofproduct/BookmarkOfProduct/components/DefaultBookmarkButton'
import {BASE_API_URL} from 'src/common/razzle-platform-bookmarkofproduct/configs'


const BookmarkOfProductButton = (props) => {

    const [inProgress, setInProgress] = useState(false)
    const {onAuth} = useAuth()
    // @ts-ignore
    const user = useSelector(({userModel}) => userModel.user)
    const dispatch = useDispatch()
    const {errorAlert, successAlert} = useAlert()
    const { formatMessage } = useIntl()
    const { productId } = props

    const isBookmarked = (usr=user) => {
        if (usr) {
            return !!_.find(usr.productBookmarks, bookmark => bookmark.product.id === productId)
        }
        return false
    }

    const addToBookmark = async() => {
        setInProgress(true)
        try {
            await axios.post(`${BASE_API_URL}product-bookmarks`, {product: productId})
            // refresh current user
            await dispatch.userModel.fetchCurrentUser()
            successAlert(formatMessage({ id: 'Le produit a été ajouté à vos favoris', defaultMessage: 'Le produit a été ajouté à vos favoris'}))
        } catch (error) {
            errorAlert(handleErrors(error))
        }
        setInProgress(false)
    }

    const deleteFromBookmark = async (usr) => {
        setInProgress(true)
        try {
            const bookmark = _.find(usr.productBookmarks, bookmark => bookmark.product.id === productId)

            await axios.delete(`${BASE_API_URL}product-bookmarks/${bookmark.id}`)
            // refresh current user
            await dispatch.userModel.fetchCurrentUser()
            successAlert(formatMessage({ id: 'Le produit a été supprimé de vos favoris', defaultMessage: 'Le produit a été supprimé de vos favoris'}))
        } catch (error) {
            errorAlert(handleErrors(error))
        }
        setInProgress(false)
    }


    const handleClick = (event) => {
        event.preventDefault()
        onAuth((usr) => {
            isBookmarked(usr) ? deleteFromBookmark(usr) : addToBookmark()
        })
    }

    const BookmarkButton = props.bookmarkButton || DefaultBookmarkButton


    return (
        <BookmarkButton onClick={handleClick} isBookmarked={isBookmarked(user)} inProgress={inProgress} />
    )
}

BookmarkOfProductButton.propTypes = {
    productId: PropTypes.string.isRequired
}


export default BookmarkOfProductButton
